export const boardMarketActionTypes = {

    UpdateBoardTPRL: "UPDATE_BOARD_TPRL",
    updateMarketTPRL: "UPDATE_MARKET_TPRL",
}

export const updateBoardTPRL = (newInfos, isInit) => {
    return {
        type: boardMarketActionTypes.UpdateBoardTPRL,
        payload: { data: newInfos, isInit: isInit }
    }
};

export const updateMarketTPRL = (newInfos, isInit) => {
    return {
        type: boardMarketActionTypes.updateMarketTPRL,
        payload: { data: newInfos, isInit: isInit }
    }
};